import { Injectable, Injector } from '@angular/core'
import { DynamicElementInterceptor, DynamicElementSpecification } from '@view-app/dynamic'

/**
 * An interceptor that will ensure that the dynamically rendered {@link CheckboxListElement} are unflattened into an array
 * when apart of an internally rendered form.
 *
 * @todo {@link https://jira.gpei.ca/browse/API-4089 API-4089}
 */
@Injectable({ providedIn: 'root' })
export class CheckboxListElementInterceptor implements DynamicElementInterceptor {

  static readonly NAME_CONTAINS_ARRAY_NOTATION = /\[\]/g

  /**
   * Lifecycle hook that will update the arguments of the dynamic element before it is built.
   *
   * If the value of the `data.name` property does not contain `[]`, then it will return a modified
   * copy of the `args` argument with `[]` appended to the `data.name` property.
   *
   * @param _injector unused
   * @param args      The pending arguments for the dynamic element
   * @param _config   unused
   *
   * @returns         Modified or original copy of the `args` argument
   */
  beforeBuild(_injector: Injector, args: DynamicElementSpecification, _config: unknown): DynamicElementSpecification {
    let name = args?.data?.name

    // If the name does not contains the required `[]`
    if (typeof name === 'string' && !CheckboxListElementInterceptor.NAME_CONTAINS_ARRAY_NOTATION.exec(name)) {
      args.data.name = `${ name }[]`
    }

    return args
  }

}
